import React from 'react'
import { useTranslation } from 'react-i18next'

// Material UI
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import MenuIcon from '@material-ui/icons/Menu'
import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import ClearIcon from '@material-ui/icons/Clear'
import Tooltip from '@material-ui/core/Tooltip'

import withWidth, { isWidthUp } from '@material-ui/core/withWidth'

const useStyles = makeStyles((theme) => ({
    typography: {
        padding: theme.spacing(1),
    },
}))

function ButtonOpenDrawer({ openDrawer,
	setOpenDrawer, width }) {
    const classes = useStyles()
    const { t } = useTranslation()

    const handleClick = (event) => {
        setOpenDrawer(!openDrawer)
    }

    return (
        <>
            <Paper
                style={{
                    marginRight: 10,
                    marginBottom: 10,
                }}
                className={classes.root}
            >
                <Tooltip title={t("ruler")}>
                    <IconButton onClick={handleClick}>
                        {!openDrawer ? (
                            <MenuIcon
                                fontSize={
                                    !isWidthUp('sm', width)
                                        ? 'small'
                                        : 'default'
                                }
                            />
                        ) : (
                            <ClearIcon
                                fontSize={
                                    !isWidthUp('sm', width)
                                        ? 'small'
                                        : 'default'
                                }
                            />
                        )}
                    </IconButton>
                </Tooltip>
            </Paper>
        </>
    )
}

export default withWidth()(ButtonOpenDrawer)
